import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import Dialog from "material-ui/Dialog";
import Typography from "material-ui/Typography";
import Grid from "material-ui/Grid";
import Card, { CardContent } from "material-ui/Card";
import classNames from "classnames";
import Loading from "../utils/loading/Loading";
import Retry from "../utils/retry/Retry";
import {
  patientRequest,
  getCategoriesRequest1,
  getCategoryVideosRequest1,
  getCategoriesDone1,
  getQrCodeVisiteRequest,
} from "./actions";
import styles from "./VideoChooser.scss";
import mur from "./WallVideo.scss";
import { getSubdomainUrl } from "./PatientPlaylistTools";

// Error
import PageError from "./404Page/404Page";

// Notifications
import Notifications from "./Notifications";

// jQuery
import poster1 from "../playlists/posterImage/thumb.png";
import MaterialIcon from "material-icons-react";
import { capitalizeFirstLetter } from "./PatientPlaylistTools";
import { push } from "react-router-redux";

class PatientView extends React.Component {
  static propTypes = {
    "video-patient": PropTypes.objectOf(PropTypes.any).isRequired,
    getCategoriesRequest1: PropTypes.func.isRequired,
    getCategoryVideosRequest1: PropTypes.func.isRequired,
    patientRequest: PropTypes.func.isRequired,
    getCategoriesDone1: PropTypes.func.isRequired,
    getQrCodeVisiteRequest: PropTypes.func.isRequired,
    // numberVisite: PropTypes.objectOf(PropTypes.any).isRequired,
  };
  constructor() {
    super();
    this.state = {
      videos: [],
      showCtogiries: true,
      categoryname: "",
      ShowDoctorInfos: false,
      VerifSiteWebRdv: false,
      showToastMessageRdv: false,
      showToastMessageWeb: false,
      VerifSiteWeb: false,
      VerifMap: false,
      showToastMessageMap: false,
      ShowGridInfosDocteur: false,
      ShowGlobalContainerVideos: true,
      ShowMap: false,
      ShowContainerPrinc: true,
      modal: false,
      currentVideo: "",
    };
    this.backtocategory = this.backtocategory.bind(this);
  }

  componentWillMount() {
    // var subdomain = window.location.hostname;
    // this.props.patientRequest({subdomain:subdomain})
    this.props.getCategoriesDone1();
  }

  componentDidMount() {
    const sd = getSubdomainUrl();
    this.props.patientRequest({ subdomain: sd });
    this.getCategories();
    this.getQrCode();
  }

  //Page stats
  getQrCode = () => {
    // console.log("getQrCode called")
    const subdomainUrl = getSubdomainUrl();
    this.props.getQrCodeVisiteRequest(subdomainUrl);
  };

  getCategories = () => {
    if (typeof this.props["video-patient"].categories === "undefined") {
      this.props.getCategoriesRequest1();
    }
  };

  handleRetryCategories = () => {
    const sd = getSubdomainUrl();
    this.props.patientRequest({ subdomain: sd });
  };

  handleRetryCategoryVideos = () => {
    const {
      "video-patient": { authData },
    } = this.props;
    const cId = this.state.selectedCategory;
    const { id } = authData.id;
    this.props.getCategoryVideosRequest1({ userId: id, categoryId: cId });
  };

  selectCategory = (category) => {
    this.props.history.push(`/patient-playlists/${category.slug}`, {});
  };

  backtocategory() {
    this.setState({
      selectedCategory: null,
      categoryname: "",
      showCtogiries: true,
      ShowGridInfosDocteur: false,
      ShowGlobalContainerVideos: true,
      ShowMap: false,
      ShowContainerPrinc: true,
    });
  }

  toggleVideo = (video) => {
    const { videos } = this.state;
    if (videos.includes(video)) {
      this.setState({
        videos: videos.filter((v) => v !== video),
      });

      return;
    }

    this.setState({
      videos: [...videos, video],
    });
  };

  forceAbsoluteLink(link) {
    if (link.indexOf("http") == -1) return "http://" + link;
    return link;
  }

  render() {
    const {
      "video-patient": {
        userinfoResquesting,
        userinfoSuccessful,
        userinfoError,
        categoriesRequesting,
        categoriesSuccessful,
        categoriesError,
        categories,
        categoryVideosRequesting,
        categoryVideosSuccessful,
        categoryVideosError,
        videos,
        authData,
      },
      // getQrCodeVisiteRequest: {
      //   subdomain,
      // }
    } = this.props;

    const infosDoctor = (mobileView = false) => <div>{/* Plus besoin */}</div>;

    return (
      <div>
        {userinfoResquesting && !userinfoSuccessful && <Loading size={80} />}

        <Dialog
          fullScreen
          open={userinfoSuccessful}
          style={{
            width: "100%",
            margin: "0",
            height: "100%",
            maxWidth: "100%",
            maxHeight: "100%",
            borderRadius: "0",
          }}
        >
          <div>
            {userinfoSuccessful && (
              <div>
                {this.state.showToastMessageRdv && <Notifications />}
                {this.state.showToastMessageWeb && <Notifications />}
                {/* {this.geocode(authData)} */}
                {!this.state.ShowDoctorInfos && this.state.showCtogiries && (
                  <div
                    className={classNames(
                      styles.videoView,
                      styles.modalBarInfoDoctor
                    )}
                  >
                    <a
                      className={styles.active}
                      onClick={() => this.viewDoctorInfos()}
                    >
                      <MaterialIcon color="#ffffff" icon="info" size={40} />
                    </a>
                    <img
                      className={styles.logoBlanc}
                      src="assets/img/DD-logo-long-blanc.png"
                    />
                  </div>
                )}

                <div className={styles.videoChooserContainer}>
                  {this.state.showCtogiries && (
                    <div>
                      <center>
                        <div className={styles.name}>
                          {authData.multiDoctorNames &&
                          authData.multiDoctorNames.length ? (
                            <div>
                              <div className={styles.cabinet}>
                                {" "}
                                Bienvenue dans notre centre
                              </div>
                              <span>
                                <b>{authData.multiDoctorNames}</b>
                              </span>
                            </div>
                          ) : (
                            <div>
                              <img
                                className={styles.logo}
                                src="assets/img/DD-logo-long-noir.png"
                              />
                              <br></br>
                              <div className={styles.cabinet}>
                                <span>
                                  <b>Bienvenue</b> dans le cabinet du docteur{" "}
                                  {capitalizeFirstLetter(authData.firstName)}{" "}
                                  {capitalizeFirstLetter(authData.lastName)}
                                </span>
                              </div>
                            </div>
                          )}
                        </div>
                      </center>
                      <center className={styles.infosDoctorToggle}>
                        {infosDoctor()}
                      </center>
                    </div>
                  )}

                  {/* Background animated */}
                  {/* BEGIN Main container for info section and videos section */}
                  {this.state.ShowContainerPrinc && (
                    <div className={styles.containerPrinc}>
                      {/* BEGIN container with informations of the doctor */}
                      {/* END container with informations of the doctor */}
                      {/* BEGIN CATEGORIES Container */}
                      {this.state.ShowGlobalContainerVideos && (
                        <div
                          className={classNames({ [styles.container]: true })}
                        >
                          {categoriesRequesting && <Loading size={80} />}
                          {this.state.showCtogiries && categoriesSuccessful && (
                            <Typography
                              type="display1"
                              align="center"
                              className="mb3"
                            >
                              {/* Title of the videos section */}
                              <b className={styles.titleVideo}>
                                Choisissez une catégorie de vidéos d'information
                                médicale
                              </b>
                            </Typography>
                          )}
                          <Grid className="mt4" container justify="center">
                            {categoriesRequesting && <Loading size={80} />}
                            {categoriesError && (
                              <Retry
                                message={categoriesError}
                                onRetry={this.handleRetryCategories}
                              />
                            )}
                            {this.state.showCtogiries &&
                              categoriesSuccessful &&
                              categories
                                .filter(
                                  (category) =>
                                    category.videoCount &&
                                    (!category.hidden ||
                                      (category.hidden &&
                                        category.visibleOnCurrentSubdomain))
                                )
                                .map((category) => (
                                  <Card
                                    id={styles.SizeVideos}
                                    key={category.id}
                                    style={{
                                      backgroundImage: `url("https://s3.eu-central-1.amazonaws.com/digidocteur/images_categories/${category.slug}.jpg")`,
                                    }}
                                    className={classNames({
                                      [styles.card]: true,
                                      [styles.categoryCard]: true,
                                    })}
                                    onClick={() =>
                                      this.selectCategory(category)
                                    }
                                  >
                                    <CardContent
                                      className={classNames({
                                        [styles.categoryCardContent]: true,
                                        [styles.categoryLabel]: true,
                                      })}
                                    >
                                      <Typography
                                        className={styles.categoryLabel}
                                        type="headline"
                                        component="h2"
                                        align="center"
                                      >
                                        {category.name}
                                      </Typography>
                                    </CardContent>
                                  </Card>
                                ))}
                          </Grid>
                          {this.state.ShowDoctorInfos &&
                            userinfoSuccessful &&
                            !this.state.showCtogiries && (
                              <div>{infosDoctor(true)}</div>
                            )}
                        </div>
                      )}
                      {/*  END CATEGORIES Container */}
                    </div>
                  )}
                  {categoryVideosError && (
                    <Retry
                      message={categoryVideosError}
                      onRetry={this.handleRetryCategoryVideos}
                    />
                  )}
                  {/* Section where all the cards are found */}
                  <section className={(mur.second, mur.clearfix)}>
                    {/* TODO I moved all videos in CategoryVideos component */}
                  </section>

                  {/* END Main container for info section and videos section */}
                </div>
                <div className={styles.bottomNavigation}>
                  <div className={styles.bottomimage}>
                    <img
                      src="/favicon.ico"
                      alt="logo"
                      height="80px"
                      width="80px"
                    />
                  </div>
                  <div className={styles.bottomtext}>
                    <center>
                      Site réalisé avec Digidocteur.com, le premier service la
                      digitalisation des
                    </center>
                    <center>cabinets de médecins en France</center>
                    <center>
                      ©2018 Digidocteur SAS - Tous droits réservés
                    </center>
                  </div>
                </div>
              </div>
            )}
          </div>
        </Dialog>

        {userinfoError && (
          <div>
            <PageError />
          </div>
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  "video-patient": state["video-patient"],
  // numberVisite: state.getQrCodeVisiteRequest,
});

export default connect(mapStateToProps, {
  getCategoriesRequest1,
  getCategoryVideosRequest1,
  getCategoriesDone1,
  patientRequest,
  getQrCodeVisiteRequest,
})(PatientView);



// WEBPACK FOOTER //
// ./src/pages/patientplaylist/PatientView.jsx